<template>
  <div>
    <div class="section1">
      <div class="banner">
        <div class="fusion-builder">
          <div class="fusion-builder-left">
            <h2><strong>Join Our Product Test Program and Get a FREE Gift*</strong></h2>
            <h3>NO Shipping Charges, NO Hidden Fees, NO Credit Card Required!</h3>
            <div class="post-content" style="transform:translate3d(0,0,0);">
              <p>
                <span>* Conditions Apply: Limited to one free gift of each product per Amazon account and household. Offer valid only for customers that bought the product at full price at <em>sm-hair.com</em> or our Official Seller on Amazon.com. To qualify participants to agree to send us their experience with the previously purchased product that they have been actively taking for at least 7 days or more.</span>
              </p>
            </div>
            <div class="fusion-full-width-sep">
              <div class="sep-solid"></div>
            </div>
            <div class="post-content" style="transform:translate3d(0,0,0);">
              <p>
                <span>1 – Only for customers that bought the product at FULL PRICE at our Official Seller on Amazon.com.<br>2 – Each customer can only claim one FREE GIFT for one product. (Which means no matter how many times you purchase the same product, you can only get one FREE gift)</span>
              </p>
            </div>
            <div class="fusion-full-width-sep">
              <div class="sep-solid"></div>
            </div>
          </div>
          <div class="fusion_builder_right">
            <h2><strong>Join Our Product Test Program and Get Your Free Gift Now!</strong></h2>
            <h5>Offer Limited to Existing Customers</h5>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item label="Name" prop="name">
                <el-input v-model="ruleForm.name" placeholder="Enter Your Name..." clearable></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <el-input v-model="ruleForm.email" placeholder="Enter Your Email..." clearable></el-input>
              </el-form-item>
              <el-form-item label="Order ID / ASIN" prop="amazonOrderId">
                <el-input v-model="ruleForm.amazonOrderId" placeholder="Amazon Order ID..." clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button v-loading.fullscreen.lock="loading" @click="submitForm('ruleForm')">ACTIVATE NOW</el-button>
              </el-form-item>
            </el-form>
            <div><a @click="$router.push('/findid')" style="cursor:pointer">*How to find your order ID?</a></div>
            <p>*We don’t share your personal info with anyone. Check out our Privacy Policy for more information.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section2">
      <h2><span style="color: #a099cb;"><strong>3 SIMPLE STEPS TO GET YOUR FREE GIFT</strong></span></h2>
      <div class="fusion-row">
        <div class="step1">
          <h4>Step 1</h4>
          <div class="btnr"><i class="el-icon-present"></i></div>
          <p class="step-title">Receive and check your product</p>
          <p class="step-content">After receiving your product, check everything is as it should be and then take a look
            at the GIFT CARD. Type the website address into your browser to join our campaign and be in with a chance to
            receive a free gift.</p>
        </div>
        <div class="step2">
          <h4>Step 2</h4>
          <div class="btnr"><i class="el-icon-tickets"></i></div>
          <p class="step-title">Simply fill in the forms</p>
          <p class="step-content">Please read the contents on the left side of the page to know what rights you have,
            then just simply fill in the form with your name, email address and order ID to join our campaign and other
            services.</p>
        </div>
        <div class="step3">
          <h4>Step 3</h4>
          <div class="btnr"><i class="el-icon-check"></i></div>
          <p class="step-title">Check and confirm</p>
          <p class="step-content">Check the information you entered and make sure it’s correct. We’ll use that
            information to find the order details for what your purchased. Just click “JOIN NOW” to go to the next stage
            where you can receive your reward.</p>
        </div>
      </div>
    </div>

    <div class="footer2">
      <p>Copyright © csvip.club<img src="../../../assets/imgs/beian.png" alt=""> <a href="https://beian.miit.gov.cn/"
                                                                                    target="_blank">粤ICP备2020126125号</a>
      </p>
    </div>
  </div>
</template>
<script>
import {
  freeGiftOrder
} from "../../../api/freeGift";
export default {
  name: 'gift',
  data() {
    // 登录界面邮箱验证
    var email = (rule, value, callback) => {
      // 邮箱正则
      const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
      // 邮箱框value判断
      if (!value) {
        callback(new Error('Mailbox cannot be empty'))
      } else if (!reg.test(value)) {
        callback(new Error('Please input correct email format'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      ruleForm: {
        name: '',
        email: '',
        amazonOrderId: ''
      },
      addForm: {},
      rules: {
        name: [
          {required: true, message: 'This field is required', trigger: 'blur'}
        ],
        email: [
          {required: true, validator: email, trigger: 'blur'}
        ],
        amazonOrderId: [
          {required: true, message: 'This field is required', trigger: 'blur'}
          // { required: true, message: 'The correct Order ID should be in format of 123-1234567-1234567, please check it before try again.', trigger: 'blur' }
        ],
      },
      isFirstEnter: false
    }
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            // 测试订单号：206-1176342-0860351
            sessionStorage.giftAmazon_order_id = this.ruleForm.amazonOrderId;
            sessionStorage.giftEmail = this.ruleForm.email;
            sessionStorage.giftName = this.ruleForm.name;
            freeGiftOrder(this.ruleForm).then((res => {
              if (res.data.code === 200) {
                this.$message.success(res.data.message);

                if(res.data.data.amazonOrderId === ""){
                  this.$router.push({
                    path:'/share-experience',
                    query:{amazonOrderId: res.data.data.describe,
                      image: "",
                      title: ""
                    }
                  });

                }else {
                  this.$router.push({
                    path: '/warranty-activated',
                    name: 'warrantyActivated',//必须带name属性，要不然参数传递不成功。
                    query: {
                      amazonOrderId: res.data.data.amazonOrderId,
                      describe: res.data.data.describe,
                      img_url: res.data.data.img_url,
                      title: res.data.data.title,
                      image: res.data.data.image
                    }
                  });
                }




                this.$refs[formName].resetFields();


              } else if (res.data.code === 201) {
                this.$router.push('/noOrderId')
              } else {
                this.$message(res.data.message);
              }
            })).finally(() => {
              this.loading = false;
            })
          } else {
            return false;
          }
        });

    },
  },
  activated() {
    // if(!this.$route.meta.isBack || this.isFirstEnter){
    // // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
    // // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
    // // 执行自己写的页面的初始化
    // //  this.init();
    // }
    // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    // this.$route.meta.isBack=false
    // // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    // this.isFirstEnter=false;
  },
  created() {
    if (sessionStorage.giftAmazon_order_id) {
      this.ruleForm.amazonOrderId = sessionStorage.giftAmazon_order_id;
    }
    if (sessionStorage.giftEmail) {
      this.ruleForm.email = sessionStorage.giftEmail;
    }
    if (sessionStorage.giftName) {
      this.ruleForm.name = sessionStorage.giftName;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
        to.path == '/gift' ||
        to.path == '/warranty-activated' ||
        to.path == '/share-experience' ||
        to.path == 'share-experience-2' ||
        to.path == 'share-experience-3' ||
        to.path == 'share-experience-4'
    ) {
      //缓存
      from.meta.keepAlive = true;
    } else {
      //不缓存
      from.meta.keepAlive = false;
    }
    next()
  }
}
</script>
<style lang="less" scoped>
// .fusion-header {
//     background-color: #6964c0;
//     height: 103px;
//     box-shadow: 0 10px 50px -2px rgb(0 0 0 / 14%);
//     .header-h1{
//         height: 100%;
//         padding: 0px 30px;
//         h1{
//             text-align: center;
//             line-height: 103px;
//             color: #ffffff
//         }
//     }
// }
.section1 {
  width: 100%;
  height: auto;
  padding-bottom: 50px;
  box-sizing: border-box;

  .banner {
    background-color: rgba(255, 255, 255, 0);
    //height: 933px;
    background-image: url('../../../assets/imgs/shutterstock_719840308.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    padding: 80px 14% 80px 14%;
    border-width: 0px 0px 0px 0px;
    border-color: #eae9e9;
    border-style: solid;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .fusion-builder {
      display: flex;
      justify-content: space-between;

      .fusion-builder-left {
        position: relative;
        z-index: 2;
        width: 45%;

        h2, h3 {
          margin: 0px;
          color: rgb(255, 255, 255);
          font-size: 32px;
          line-height: 1.31;
        }

        h3 {
          font-size: 18px;
          margin: 30px 0px;
          // color: #333333;
        }

        .post-content {
          p {
            margin-top: 0;
            margin-bottom: 20px;
            font-size: 16px;
            color: #ffffff;
            line-height: 26px;
          }
        }

        .fusion-full-width-sep {
          margin-left: auto;
          margin-right: auto;
          margin-top: 10px;
          margin-bottom: 30px;
          width: 100%;

          .sep-solid {
            // height: 2px;
            border-color: #ffffff;
            border-top-width: 2px;
            flex-grow: 2;
            border: 1px solid #e7e6e6;
          }
        }
      }

      .fusion_builder_right {
        position: relative;
        z-index: 2;
        //padding: 20px;
        //background-color: rgba(255, 255, 255, 0.8); /* 背景颜色加透明度 */
        //border-radius: 10px;

        margin-left: 50px;
        width: 50%;
        background-color: rgb(255, 255, 255);
        border-radius: 30px;
        //overflow: hidden;
        padding: 30px 12%;
        min-height: 0px;

        h2 {
          strong {
            margin: 0px;
            line-height: 40px;
            font-size: 32px;
          }
        }

        h5 {
          margin: 0px;
          line-height: 1.4;
          font-size: 20px;
          margin-top: 20px;
          margin-bottom: 10px;
          font-weight: normal;
          color: #747474;
        }

        .el-input,
        .el-button {
          width: 100%;
          height: 32px;
        }

        .el-button {
          height: 40px;
          background: #a099cb;
          color: #ffffff;
          margin-bottom: 20px;
        }

        .el-button:hover {
          background-color: #887ecc;
        }

        a {
          color: #a099cb;
          font-size: 20px;
        }

        p {
          margin-top: 10px;
          font-size: 20px;
          line-height: 1.4;
          color: #747474;
        }
      }
    }

  }

  .banner::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5); /* 调整透明度 */
    z-index: 1;
  }

}

.section2 {
  background-color: #ffffff;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 60px 8%;
  margin-bottom: 0px;
  margin-top: 0px;
  border-width: 0px 0px 0px 0px;
  border-color: #eae9e9;
  border-style: solid;

  h2 {
    text-align: center;
    color: rgb(239, 129, 163);
    font-size: 32px;
    line-height: 1.31;
    margin-bottom: 30px;
  }

  .fusion-row {
    display: flex;
    justify-content: space-around;
    // background-color: #fff;
    .step1,
    .step2,
    .step3 {
      width: 358px;
      height: 423px;
      display: flex;
      flex-direction: column;
      align-items: center;

      h4 {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .btnr {
        font-size: 61.6px;
        // line-height: 121.2px;
        height: 123.2px;
        width: 123.2px;
        line-height: 123.2px;
        border-radius: 50%;
        margin-top: 20px;
        margin-bottom: 20px;
        color: #ffffff;
        background-color: #a099cb;
        border-color: #ffffff;
        text-align: center;
      }

      .step-title {
        font-size: 22px;
        margin-bottom: 10px;
        font-weight: bold;
      }

      .step-content {
        margin-bottom: 20px;
        transform: translate3d(0, 0, 0);
        font-size: 16px;
        line-height: 1.7;
        text-align: center;
        color: #747474;
      }
    }
  }
}

.footer2 {
  // position: relative;
  // left: 40%;
  bottom: 0px;
  position: fixed;
  width: 100%;
  // left: 40%;
  text-align: center;
  background-color: rgb(245, 245, 245);
  color: #0A0A0A;
  height: 50px;
  line-height: 50px;

  p {
    left: 50%;
    // left: 50%;
    img {
      margin: 0px 6px;
    }

    a {
      color: #337ab7;
    }
  }

}
</style>